var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMicrosoftWord(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#2A5699"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 16v-1h6v1h-6zm0 2v-1h6v1h-6zm0 2v-1h6v1h-6zm0 2v-1h6v1h-6zm3.398-14L24 12.602V24H11v-2.625l-3-.477V12l3-.43V8h8.398zm-7.875 7.703h.008l.649 2.82h.883l.937-4h-.805l-.539 2.954h-.015l-.633-2.954h-.86l-.71 2.938h-.016l-.547-2.938H9l.93 4h.922l.671-2.82zM23 23v-9h-7v-1h2v-1h-2v-1h2V9h-6v2.43l3-.43v11l-3-.469V23h11zm-4-10h4l-4-4v4z",
    fill: "#fff"
  })));
}

export default SvgMicrosoftWord;